<template>
  <div>
    <v-dialog v-model="change_order_report" max-width="1000" persistent scrollable>
      <v-card :loading="loading">
        <v-card-title class="p-0" style="padding: 0px !important;">
          <v-col cols="9" style="font-size: 18px; padding: 0px" class="text-center mt-1">
            <b style="color: #666666">Change Order</b>
          </v-col>
          <v-col cols="3" class="p-0" style="padding: 13px !important;">
            <v-col class="text-right fs-12" style="padding:0px !important;">{{report_header_name}}</v-col>
            <b>
              <v-select
                :items="change_order_list"
                item-text="change_order"
                item-value="change_order"
                v-model="change_order_id"
                hide-details
                dense
                style="margin-top: -5px"
                @change="getAllChangeOrderData()"
              ></v-select>
            </b>
          </v-col>
        </v-card-title>
        <v-divider class></v-divider>
        <v-card-text class style="height: 100%">
          <v-row dense class="mt-3">
            <v-col cols="4">
              <v-row dense>
                <v-col cols="3" style="max-width: 22%">
                  <v-img :src="company_details.logo_path" width="60"></v-img>
                </v-col>
                <v-col class="license-number" style="line-height: 18px">
                  <div style="font-size: 16px">{{ company_details.name }}</div>
                  <div class="ml-2">{{ company_details.license_number }}</div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="4" class="text-center">
              <div class="ml-2" style="font-size: 18px">
                <!-- <i
                  ><b>Since {{ company_details.company_start_year }}</b></i
                >-->
              </div>
            </v-col>
            <v-col cols="4" class="text-right">
              Tel :
              <b>{{ company_details.phone_number }}</b>
              <br />
              <a
                :href="company_details.website_link"
                target="_blank"
              >{{ company_details.website_link }}</a>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              {{ company_details.shipping_address_line_1 }}
              <br />
              {{ company_details.shipping_city_details.city_name }},
              {{ company_details.shipping_state_details.short_name }}
              {{ company_details.shipping_zip }}
            </v-col>
            <v-col cols="6" class="text-right">
              {{
              company_details.email +
              "@" +
              company_details.domain_details.domain
              }}
            </v-col>
          </v-row>
          <v-row dense class="custom-font-for-print mt-2">
            <v-col
              cols="12"
              class="grey lighten-2 mt-1"
              style="font-size: 18px; text-align: center"
            >Change Order  : {{change_order_id}}</v-col>
            <v-col cols="12" class="mt-2">
                <v-simple-table dense class="custom-table-border text-center">
                <tbody>
                  <tr>
                    <td><b>Project</b></td>
                    <td><b>Address</b></td>
                    <td><b>Job Address</b></td>
                    <td><b>Change Order Date</b></td>
                  </tr>
                  <tr>
                    <td width="27%">{{ project_details.p_name }}</td>
                    <td>
                      {{ project_details.p_address_1
                      }}{{
                      project_details.p_address_2
                      ? ", " + project_details.p_address_2
                      : ""
                      }}
                      <br />
                      {{
                      project_details.city
                      ? "" + project_details.city.city_name
                      : ""
                      }}{{
                      project_details.state
                      ? ", " + project_details.state.state_name
                      : ""
                      }}{{
                      project_details.p_zip
                      ? "-" + project_details.p_zip
                      : ""
                      }}
                    </td>
                    <td>{{ project_details.bill_to_address_1 }} 
                      <br/>
                      {{(project_details.bill_to_city_details)?project_details.bill_to_city_details.city_name+',':''}} {{(project_details.bill_to_state_details)?project_details.bill_to_state_details.short_name:''}} {{project_details.bill_to_zip}}
                    </td>
                    <td>{{ change_order_date }}</td>
                  </tr>
                  <tr>
                    <td colspan="4" class="contract_div" width="27%" style="background-color: #000;  color: #fff;" >
                      <b>
                        The Contract Time will be
                        <v-col cols="2" class="d-inline-flex">
                          <v-select
                            :items="contract_time_list"
                            v-model="contract_time"
                            hide-details
                            dense
                            @change="setContractType();saveTempReportData()"
                            style="margin-top: -5px; max-width: 100%"
                          ></v-select>
                        </v-col>
                        <span v-if="contract_time!='unchanged'">
                          by
                          <v-col cols="1" class="d-inline-flex">
                            (
                            <v-text-field
                              single-line
                              dense
                              hide-details
                              v-model="contract_day"
                              @change="saveTempReportData()"
                              style="margin-top: -5px; "
                            ></v-text-field>)
                          </v-col>
                           Days
                          <!-- <v-col cols="2" class="d-inline-flex contract_div">
                            <v-select
                              :items="co_time_type_list"
                              v-model="co_time_type"
                              hide-details
                              dense
                              style="margin-top: -5px;"
                            ></v-select>
                          </v-col> -->
                        </span>
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td><b>Contract Date</b></td>
                    <td><b>Contract Completion Date</b></td>
                    <td><b>Revised Completion Date</b></td>
                    <td><b>New Completion date</b></td>
                  </tr>
                  <tr>
                    <td>{{ contract_date }}</td>
                    <td>{{ estimated_completed_date }}</td>
                    <td>{{ revised_completion_date }}</td>
                    <td style="background-color: #000;color: #ffffff !important;" >{{new_substantial_completion_date}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col
              cols="12"
              class="grey lighten-2 mt-1"
              style="font-size: 14px; text-align: center"
            >The Contract is changed as follows :</v-col>
            <v-col cols="12" class="mt-2">
              <v-data-table
                class="elevation-1 mt-1 rounded-0 my-transaction-table"
                :items="items"
                hide-default-footer
                mobile-breakpoint="50"
                dense
                disable-pagination
              >
                <template v-slot:body.prepend>
                  <tr class="header-background right-border-white">
                    <td width="5%" class="text-center">Sr No.</td>
                    <td width="45%" class="text-left">Description</td>
                    <td width="20%" class="text-center">Area</td>
                    <td width="10%" class="text-center">Qty</td>
                    <td width="10%" class="text-center" v-if="is_with_rate">Rate</td>
                    <td width="10%" class="text-center">Amount</td>
                  </tr>
                </template>
                <template v-slot:item="{ item, index }">
                  <tr class="right-border-grey">
                    <td width="5%" style="text-align: center">{{ index + 1 }}</td>
                    <td width="45%" style="text-align: left">
                      <b>
                        <u>{{ item.group_name }}</u>
                      </b>
                      <br />
                      <span style="font-size:14px !important; ">{{ item.item_name }}</span>
                      <br />
                      <span style="font-size:14px !important;">{{ item.description }}</span>
                    </td>
                    <td width="20%" style="text-align: center">{{ item.area }}</td>
                    <td
                      width="10%"
                      style="text-align: center"
                      :class="row_qty_rate_color(item.qty)"
                    >{{ itemFormat(item.qty) }}</td>
                    <td
                      width="10%"
                      style="text-align: center"
                      :class="row_qty_rate_color(item.rate)"
                      v-if="is_with_rate"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <span>{{ itemFormatWithDollar((item.total_group_amount/item.qty).toFixed(2))}}</span>
                          </span>
                        </template>
                        <span>{{ itemFormatWithDollar(item.rate)}}</span>
                      </v-tooltip>
                    </td>
                    <td
                      width="10%"
                      style="text-align: right"
                      :class="row_qty_rate_color(item.total_group_amount)"
                    >{{ itemFormatWithDollar(item.total_group_amount.toFixed(2)) }}</td>
                  </tr>
                </template>
                <template v-slot:body.append>
                  <tr>
                    <td :colspan="is_with_rate ? 5 : 4" class="border-right"></td>
                    <td
                      class="text-right grey lighten-2"
                      :class="row_qty_rate_color(total_schedule)"
                    >{{ itemFormatWithDollar(total_schedule) }}</td>
                  </tr>
                  <tr>
                    <td
                      :colspan="is_with_rate ? 5 : 4"
                      class="border-right"
                    >Original Contract Amount</td>
                    <td
                      class="text-right"
                      :class="row_qty_rate_color(original_contract_amount)"
                    >{{ itemFormatWithDollar(original_contract_amount) }}</td>
                  </tr>
                  <tr>
                    <td
                      :colspan="is_with_rate ? 5 : 4"
                      class="border-right"
                    >The net change by Previously authorized Change Orders</td>
                    <td
                      class="text-right"
                      :class="row_qty_rate_color(pre_change_order_amount)"
                    >{{ itemFormatWithDollar(pre_change_order_amount) }}</td>
                  </tr>
                  <tr>
                    <td
                      :colspan="is_with_rate ? 5 : 4"
                      class="border-right"
                    >The Contract Sum prior to this Change order was</td>
                    <td
                      class="text-right"
                      :class="row_qty_rate_color(prior_order_amount)"
                    >{{ itemFormatWithDollar(prior_order_amount) }}</td>
                  </tr>
                  <tr>
                    <td :colspan="is_with_rate ? 5 : 4" class="border-right">
                      The Contract sum will be increased by this change order in
                      amount of
                    </td>
                    <td
                      class="text-right"
                      :class="row_qty_rate_color(increased_contract_amount)"
                    >{{ itemFormatWithDollar(increased_contract_amount) }}</td>
                  </tr>
                  <tr>
                    <td
                      :colspan="is_with_rate ? 5 : 4"
                      class="border-right"
                    >The New contract sum including this change order will be</td>
                    <td
                      class="text-right"
                      :class="row_qty_rate_color(new_change_order_amount)"
                    >{{ itemFormatWithDollar(new_change_order_amount)}}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
            <v-col cols="12" class="mt-1" style="font-size: 14px">
              (Note: This Change Order does not include changes in Contract
              Sum, Contract Time have been authorized by Construction Change
              Directive until the cost and time have been agreed upon by both
              the Owner and Contractor, in which case a change order is executed
            </v-col>
            <v-col
              cols="12"
              class="mt-1"
              style="font-size: 14px"
            >NOT VALID UNTIL SIGNED BY THE CONTRACTOR AND OWNER</v-col>
            <v-col cols="12">
              <v-row dense class="ml-1">
                <v-col cols="12" class="mt-1" style="text-align: center"></v-col>
                <v-col cols="3">
                  <v-divider style="margin-top: 45px"></v-divider>OWNER
                  (Signature)
                  <br />
                  {{ project_details ? project_details.customer ? project_details.customer.full_name:'':'' }}
                </v-col>
                <v-col cols="6"></v-col>
                <v-col cols="3">
                  <v-divider style="margin-top: 45px"></v-divider>CONTRACTOR
                  (Signature)
                  <br />
                  {{ company_details.name }} ({{
                  company_details.license_number
                  }})
                  <br />
                  {{ company_details.contact_person }} (President)
                  <br />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class></v-divider>
        <v-card-actions>
          <v-btn color="error" @click="closePopup()" :disabled="loading">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading"
            @click="generateReport('whole_page', true);
              is_send_report = false;
            "
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-printer</v-icon>Print
          </v-btn>
          <v-btn
            :loading="loading"
            @click="
              generateReport(false);
              is_send_report = false;
              preview_pdf_dialog = true;
            "
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-content-save-outline</v-icon>Sign Online
          </v-btn>
          <v-btn
            @click="
              preview_pdf_dialog = true;
              is_send_report = true;
              generateReport(false);
            "
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-send</v-icon>Send for Signature
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="preview_pdf_dialog" max-width="800" persistent>
      <v-card :loading="preview_pdf_loading">
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <iframe :src="preview_page_link" frameborder="0" style="width:100%;height:800px"></iframe>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="error"
            @click="preview_pdf_dialog = false; user_sign_blob = []; customer_sign_blob = ''; active_page = 0;"
          >Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="is_send_report ? email_dialog = true : signature_dialog = true"
            v-if="total_page == active_page"
            :loading="preview_pdf_loading"
          >Finish</v-btn>
          <v-btn
            v-else
            color="primary"
            class="text-capitalize"
            @click="is_send_report ? generateReport(false) : signature_dialog = true;"
            :loading="preview_pdf_loading"
          >Next Page</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SendMailDialog
      :email_id="email_ids"
      :email_dialog="email_dialog"
      @closeDialog="closeSendMailDialog"
      @sendMail="sendMail"
    />
    <Signatura
      :customer_sign="customer_sign_blob"
      :active_page="active_page"
      @updateValue="updateParent"
      @clearValue="clearParent"
      :project_details="project_details"
      :signature_dialog="signature_dialog"
    />
  </div>
</template>
 <script>
import { getCompanyDetails } from "../../plugins/helper";
import Signatura from "../projects/Signatura";
import SendMailDialog from "../projects/SendMailDialog";
import axios from "../../plugins/axios";
import { mapMutations } from "vuex";
const moment = require("moment");
export default {
  data() {
    return {
      preview_pdf_loading: "",
      total_page: "",
      active_page: 0,
      user_sign_blob: [],
      customer_sign_blob: "",
      signature_dialog: false,
      loading: false,
      is_send_report: false,
      email_ids: null,
      email_id_arr: [],
      email_ids_error: null,
      email_dialog: false,
      send_pdf_loading: false,
      items: [],
      company_details: getCompanyDetails(),
      preview_pdf_dialog: false,
      preview_page_link: "",
      project_data_flag: "",
      total_schedule: "",
      original_contract_amount: "",
      pre_change_order_amount: "",
      prior_order_amount: "",
      increased_contract_amount: "",
      new_change_order_amount: "",
      project_name: "",
      project_no: "",
      customer_name: "",
      contract_date: "",
      change_order_list: [],
      contract_time: "unchanged",
      contract_day: "",
      completion_date: "",
      change_order_date: "",
      next_change_order_id: "",
      co_time_type: "",
      revised_completion_date: "",
      estimated_completed_date: "",
      old_contract_day: "",
      old_contract_time :"",
      co_time_type_list: [
        {
          text: "Day",
          value: "days"
        },
        // {
        //   text: "Month",
        //   value: "months"
        // },
        // {
        //   text: "Year",
        //   value: "years"
        // }
      ],
      contract_time_list: [
        {
          text: "Increased",
          value: "increased"
        },
        {
          text: "Decreased",
          value: "decreased"
        },
        {
          text: "Unchanged",
          value: "unchanged"
        }
      ],
      invoice_no: "0",
      change_order_id: 1
    };
  },
  props: [
    "change_order_report",
    "project_details",
    "generate_invoice_project",
    "selectedRows",
    "invoice_id",
    "is_with_rate",
    "report_header_name"
  ],
  watch: {
    change_order_report: function(value) {
      if (value) {
        if (this.invoice_id) {
          this.invoice_no = this.invoice_id;
        }
        this.getData();
      }
    },
    generate_invoice_project: function(value) {
      if (value) {
        this.getData();
      }
    },
    selectedRows: function(value) {
      this.items = this.items.filter(item => {
        item.current_period = 0;
        return item;
      });
      this.items = this.items.filter(item2 => {
        value.filter(item => {
          if (item2.invoice_group_id == item.invoice_group_id) {
            item2.current_period =
              parseFloat(item2.current_period) + parseFloat(item.rev_amount);
          }
        });
        return item2;
      });
    }
  },
  computed: {
    user_name() {
      return localStorage.getItem("user_name");
    },
    new_substantial_completion_date() {
      let completion_date = moment(this.estimated_completed_date).format("DD-MM-YYYY");
        let new_date;
        let days;
        if((this.old_contract_time != this.contract_time) || ((Math.abs(this.old_contract_day)) != this.contract_day)){
          if (this.contract_time == "decreased") {
              days = parseFloat(this.total_change_days) - parseFloat(Math.abs(this.old_contract_day)) - parseFloat(this.contract_day);
          }else if (this.contract_time == "increased") {
              days = parseFloat(this.total_change_days) - parseFloat(Math.abs(this.old_contract_day)) + parseFloat(this.contract_day);
          }else{
              days = parseFloat(this.total_change_days) -  parseFloat(this.old_contract_day);
          }        
          if (days > 0 ) {
            new_date = moment(completion_date, "DD-MM-YYYY").add(days, this.co_time_type);
            return moment(new_date).format("MM/DD/YYYY");
          } else if (days < 0) {
            new_date = moment(completion_date, "DD-MM-YYYY").subtract( days, this.co_time_type);
            return moment(new_date).format("MM/DD/YYYY");
          }else{
            new_date = moment(completion_date, "DD-MM-YYYY").add(days, this.co_time_type);
            return moment(new_date).format("MM/DD/YYYY");
          }
          
        }else{
          new_date = this.new_revised_completion_date;
          return new_date ? moment(new_date).format("MM/DD/YYYY") : '';
        }
      // if (this.contract_time == "decreased") {
      //   console.log("decreased", this.contract_day, this.co_time_type);
      //   new_date = moment(completion_date, "DD-MM-YYYY").subtract(
      //     this.contract_day,
      //     this.co_time_type
      //   );
      //   return moment(new_date).format("MM/DD/YYYY");
      // } else if (this.contract_time == "increased") {
      //   console.log("increased", this.contract_day, this.co_time_type);
      //   new_date = moment(completion_date, "DD-MM-YYYY").add(
      //     this.contract_day,
      //     this.co_time_type
      //   );
      //   return moment(new_date).format("MM/DD/YYYY");
      // } else {
      //   new_date = this.completion_date;
      //   return moment(new_date).format("MM/DD/YYYY");
      // }
    }
  },
  components: {
    Signatura,
    SendMailDialog
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    row_qty_rate_color(val) {
      if (val < 0) {
        return "red--text";
      }
    },
    itemFormat(val) {
      if (val < 0) {
        val = val.toString();
        val = val.replace("-", "");
        return "(" + val + ")";
      } else {
        return val;
      }
    },
    itemFormatWithDollar(val) {
      if (val < 0) {
        val = val.toString();
        val = val.replace("-", "");
        return "($" + val + ")";
      } else {
        return "$" + val;
      }
    },
    setContractType(){
    this.co_time_type = "days";
    this.contract_day = "1" ;
    }, 
    getData() {
      if (this.project_details.project_work[0].project_work == "remodeling") {
        this.project_data_flag = 2;
      } else if (
        this.project_details.project_work[0].project_work == "new_construction"
      ) {
        this.project_data_flag = 1;
      } else if (
        this.project_details.project_work[0].project_work ==
        "project_management"
      ) {
        this.project_data_flag = 4;
      }
      this.next_change_order_id = this.project_details.p_lock
        ? this.project_details.last_change_order + parseFloat(1)
        : this.project_details.last_change_order;
      console.log("next_change_order_id", this.next_change_order_id);

      this.preview_page_link = "";
      this.active_page = 0;
      this.user_sign_blob = [];
      this.customer_sign_blob = "";
      this.getChangeOrderList();
      this.getTotalPage();
      // this.getAllChangeOrderData();
    },

    sendMail(variable) {
      this.email_id_arr = variable;
      this.sendSalesInvoiceReport();
    },
    closeSendMailDialog() {
      this.email_dialog = false;
      this.preview_pdf_dialog = false;
      this.user_sign_blob = [];
      this.customer_sign_blob = "";
      this.active_page = 0;
    },
    saveTempReportData() {
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      var formData = new FormData();
      formData.append("project_id", this.project_details.project_id);
      formData.append("user_name", localStorage.getItem("user_id"));
      formData.append("company_id", company_data.company_id);
      formData.append("report_name", "change_order");
      formData.append("report_header_name", this.report_header_name);
      formData.append("contract_time", this.contract_time);
      formData.append("contract_day", this.contract_day);
      formData.append("co_time_type", this.co_time_type);
      formData.append("change_order_id", this.change_order_id);
      formData.append(
        "new_substantial_completion_date",
        this.new_substantial_completion_date
      );
      formData.append("is_with_rate", this.is_with_rate);
      formData.append("revised_completion_date", this.revised_completion_date);
      this.loading = true;
      axios
        .post("save_temp_report_data", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.status) {
            this.total_page = response.data.total_page;
          }
          this.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.loading = false;
        });
    },
    updateParent(variable) {
      if (variable.user_sign_blob) {
        this.user_sign_blob.push({
          page: this.active_page,
          sign_blob: variable.user_sign_blob
        });
      }
      if (variable.customer_sign_blob && this.active_page == 1) {
        this.customer_sign_blob = variable.customer_sign_blob;
      }
      this.signature_dialog = false;
      if (this.is_send_report) {
        if (this.total_page == this.active_page) {
          this.email_dialog = true;
          this.email_ids =
            this.project_details.customer.email +
            "@" +
            this.project_details.customer.email_domain.domain;
        } else {
          this.generateReport(false);
        }
      } else {
        if (this.total_page == this.active_page) {
          this.generateReport(true);
        } else {
          this.generateReport(false);
        }
      }
    },
    clearParent(variable) {
      console.log(variable);
      this.signature_dialog = false;
    },
    closePopup() {
      this.$emit("updateValue");
      this.change_order_list = [];
      this.change_order_id = 1;
    },
    getTotalPage() {
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      var formData = new FormData();
      formData.append("project_id", this.project_details.project_id);
      formData.append("user_name", localStorage.getItem("user_id"));
      formData.append("company_id", company_data.company_id);
      formData.append("generate_pdf_flag", "get_total");
      formData.append("project_data_flag", this.project_data_flag);
      formData.append("report_name", "change_order");
      formData.append("report_header_name", this.report_header_name);
      formData.append("change_order_id", this.change_order_id);
      formData.append("change_order_date", this.change_order_date);
      formData.append("contract_time", this.contract_time);
      formData.append("contract_day", this.contract_day);
      formData.append("co_time_type", this.co_time_type);
      formData.append("new_substantial_completion_date",this.new_substantial_completion_date);
      formData.append("is_with_rate", this.is_with_rate);
      formData.append("revised_completion_date",this.revised_completion_date);
      
      this.loading = true;
      axios
        .post("generate_report_pdf", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.status) {
            this.total_page = response.data.total_page;
          }
          this.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.loading = false;
        });
    },
    generateReport(is_past_page, direct_print = false) {
      this.preview_pdf_loading = true;
      this.active_page++;
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      // let url = 'flag=save&project_id='+this.project_details.project_id+'&user_name='+localStorage.getItem('user_id')+'&company_id='+company_data.company_id+'&sign='+this.sign_blob;
      var formData = new FormData();

      if (is_past_page) {
        if (this.user_sign_blob) {
          for (let key in this.user_sign_blob) {
            formData.append(
              `user_sign_blob[${this.user_sign_blob[key].page}]`,
              this.user_sign_blob[key].sign_blob
            );
          }
        }
        if (this.customer_sign_blob) {
          formData.append(`customer_sign_blob`, this.customer_sign_blob);
        }
        formData.append("generate_pdf_flag", "whole_page");
      } else {
        formData.append("generate_pdf_flag", "single_page");
      }
      formData.append("flag", "save");
      formData.append("project_id", this.project_details.project_id);
      formData.append("user_name", localStorage.getItem("user_id"));
      formData.append("company_id", company_data.company_id);
      formData.append("total_page", this.total_page);
      formData.append("active_page", this.active_page);
      formData.append("project_data_flag", this.project_data_flag);
      formData.append("report_name", "change_order");
      formData.append("report_header_name", this.report_header_name);
      formData.append("direct_print", direct_print);
      formData.append("generate_invoice_id", this.invoice_no);
      formData.append("change_order_id", this.change_order_id);
      formData.append("change_order_date", this.change_order_date);
      formData.append("contract_time", this.contract_time);
      formData.append("contract_day", this.contract_day);
      formData.append("co_time_type", this.co_time_type);
      formData.append("new_substantial_completion_date",this.new_substantial_completion_date);
      formData.append("revised_completion_date",this.revised_completion_date);
      formData.append("is_with_rate", this.is_with_rate);
      axios
        .post("generate_report_pdf", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (is_past_page) {
            if (response.data.status) {
              if (direct_print) {
                var File_url = response.data.file_url;
                window.open(File_url, "Download");
              } else {
                this.setAlert({
                  show: true,
                  variant: "primary",
                  message: response.data.message,
                  dismissCountDown: 0
                });
                this.closePopup();
              }
              this.preview_pdf_dialog = false;
            }
          } else {
            this.preview_page_link = response.data.preview_page_link;
          }
          this.preview_pdf_loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.preview_pdf_loading = false;
        });
    },
    sendSalesInvoiceReport() {
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      let data = {
        flag: "mail",
        project_id: this.project_details.project_id,
        user_name: localStorage.getItem("user_id"),
        company_id: company_data.company_id,
        active_page: this.active_page,
        total_page: this.total_page,
        email_id_arr: this.email_id_arr,
        email_ids: this.email_ids,
        generate_pdf_flag: "whole_page",
        project_data_flag: this.project_data_flag,
        report_name: "change_order",
        report_header_name: this.report_header_name,
        change_order_id: this.change_order_id,
        contract_time: this.contract_time,
        contract_day: this.contract_day,
        co_time_type: this.co_time_type,
        new_substantial_completion_date: this.new_substantial_completion_date,
        change_order_date: this.change_order_date,
        is_with_rate: this.is_with_rate,
        revised_completion_date: this.revised_completion_date,

      };
      if (this.user_sign_blob) {
        data.user_sign_blob = this.user_sign_blob;
      }
      if (this.customer_sign_blob) {
        data.customer_sign_blob = this.customer_sign_blob;
      }

      this.send_pdf_loading = true;
      axios
        .post("generate_report_pdf", data)
        .then(response => {
          this.email_ids_error = null;
          if (response.data.status) {
            this.email_dialog = false;
            this.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0
            });
            this.preview_pdf_dialog = false;
            this.closePopup();
          } else {
            this.email_ids_error = response.data.errors["email_ids"];
          }
          this.send_pdf_loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.send_pdf_loading = false;
        });
    },

    getAllChangeOrderData() {
      let _self = this;
      let change_order_id = _self.change_order_id;
      _self.loading = true;
      axios
        .get(
          "get_all_change_order_detail?project_id=" +
            this.project_details.project_id +
            "&project_data_flag=" +
            this.project_data_flag +
            "&change_order_id=" +
            change_order_id
        )
        .then(response => {
          let response_data = response.data;
          _self.items = response_data.data;
          _self.project_name = response_data.project_name;
          _self.project_no = response_data.project_no;
          _self.customer_name = response_data.customer_name;
          _self.contract_date = response_data.contract_date;
          _self.total_schedule = response_data.total_schedule;
          _self.original_contract_amount = response_data.original_contract_amount;
          _self.pre_change_order_amount = response_data.pre_change_order_amount;
          _self.prior_order_amount = response_data.prior_order_amount;
          _self.increased_contract_amount = response_data.increased_contract_amount;
          _self.new_change_order_amount = response_data.new_change_order_amount;
          _self.completion_date = response_data.completion_date;
          _self.change_order_date = response_data.change_order_date;
          _self.contract_time = response_data.contract_time;
          _self.contract_day =response_data.contract_day ? Math.abs(response_data.contract_day) : 0;
          _self.co_time_type = response_data.co_time_type;
          _self.revised_completion_date = response_data.revised_completion_date ? moment(response_data.revised_completion_date).format("MM/DD/YYYY") : '-';
          _self.new_revised_completion_date = response_data.new_revised_completion_date ? moment(response_data.new_revised_completion_date).format("MM/DD/YYYY") : '';
          _self.estimated_completed_date =  response_data.estimated_completed_date;
          _self.total_change_days = response_data.total_change_days;
          _self.old_contract_day = response_data.contract_day ? response_data.contract_day : 0;
          _self.old_contract_time = response_data.contract_time;
          _self.loading = false;
          
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
    },
    getChangeOrderList() {
      let _self = this;
      this.loading = true;
      axios
        .get(
          "get_project_change_order_list?project_id=" +
            this.project_details.project_id
        )
        .then(response => {
          let response_data = response.data;
          response_data.change_order_list.map(function(item, index) {
            if (index == 0) {
              _self.change_order_id = item.change_order;
            }
            _self.change_order_list.push(item);
          });
          this.getAllChangeOrderData();
          _self.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
    }
  },
  created: function() {},
  mounted: function() {
    // this.$refs.userSignaturePad.openSignaturePad();
    // this.$refs.customerSignaturePad.openSignaturePad();
  }
};
</script>
 
 <style scoped> 
.sales-invoice-report p {
  margin-bottom: 0px;
}
.v-select__selection {
  max-width: 100% !important;
}
.contract_div .v-select__selection--comma{
  color:#ffffff !important;
}
.contract_div .theme--light.v-input input{
  color:#ffffff !important;
  text-align: center;
}
</style>